export const description =
  "Prime énergie 2026 (CEE) : guide complet du dispositif des Certificats d'Économies d'Énergie. Mécanisme, obligés/délégataires/mandataires, fiches résidentielles BAR-TH, BAR-EN, BAR-EQ, Coups de pouce, conditions, démarches, cumul avec MaPrimeRénov’. Sans condition de ressources.";
